import React, { Component } from 'react';
import TextField from '@mui/material/TextField';
import { FormControlLabel, FormLabel, IconButton, InputAdornment, Switch } from '@mui/material';
import StartConversation from './startConversation';
import FacilityCommunicationBreadcrumb from './facilityCommunicationBreadcrumb';
import { MobileDateTimePicker } from '@mui/x-date-pickers';
import EventIcon from '@mui/icons-material/Event';

class SearchMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            from_date: this.props.from_date,
            to_date: this.props.to_date,
            pickerOpened: false
        };
    }

    render() {
        return (
            <div>
                <FacilityCommunicationBreadcrumb />
                <div className="row" style={{ padding: '12px' }}>
                    <div className="col-md-5">
                        <div className="col-md-12 row" style={{ marginBottom: '10px' }}>
                            <div className="col-md-8">
                                <TextField
                                    label="Current Grid Search"
                                    variant="outlined"
                                    id="reset-form"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    type="string"
                                    margin="dense"
                                    onChange={this.props.onFilterTextChange}
                                />
                            </div>
                            <div className="col-md-4">
                                <button className="btn btn-primary button-info-grid" onClick={() => this.props.clearFilter()}>
                                    <i className="fa fa-times" aria-hidden="true"></i> Clear Filter
                                </button>
                            </div>
                        </div>

                        <FormControlLabel
                            value="includeArchived"
                            control={
                                <Switch
                                    checked={this.props.showArchived}
                                    onChange={this.props.onShowArchived}
                                />
                            }
                            label={this.props.showArchived ? 'Hide Archives' : 'Show Archives'}
                            labelPlacement="end"
                            className="m-0 col-md-12 breadcrumb-control breadcrumb-control"
                        />
                    </div>

                    <div className="col-md-4 col-12" style={{ marginTop: '5px' }}>
                        <div className="row" style={{ paddingLeft: '10px' }}>
                            <div className="col-12">
                                <FormLabel
                                    className="col-md-6"
                                    style={{ marginBottom: '10px' }}
                                >
                                    Date Range
                                </FormLabel>
                                <FormControlLabel
                                    value="includeDate"
                                    control={
                                        <Switch
                                            checked={this.props.filterByDate}
                                            onChange={this.props.onFilterByDate}
                                        />
                                    }
                                    label={this.props.filterByDate ? 'On' : 'Off'}
                                    labelPlacement="end"
                                    className="m-0 col-md-6 breadcrumb-control breadcrumb-control"
                                />
                            </div>
                            <div className="dateRangeBar dateRangeBarPickers">
                                <MobileDateTimePicker
                                    value={
                                        this.state.pickerOpened ? this.state.from_date : this.props.from_date
                                    }
                                    onChange={(dateTime) =>
                                        this.setState({
                                            from_date: dateTime
                                        })
                                    }
                                    onOpen={() =>
                                        this.setState({
                                            from_date: this.props.from_date,
                                            pickerOpened: true
                                        })
                                    }
                                    onClose={() =>
                                        this.setState({
                                            pickerOpened: false
                                        })
                                    }
                                    onAccept={(dateTime) =>
                                        this.props.handleDateFiltersChange(dateTime.$d, 'from_date')
                                    }
                                    label="From Date"
                                    renderInput={(props) => (
                                        <TextField
                                            {...props}
                                            className="ml-1 mr-2 mt-2"
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton edge="end">
                                                            <EventIcon />
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    )}
                                />
                                <MobileDateTimePicker
                                    value={this.state.pickerOpened ? this.state.to_date : this.props.to_date}
                                    onChange={(dateTime) =>
                                        this.setState({
                                            to_date: dateTime
                                        })
                                    }
                                    onOpen={() =>
                                        this.setState({
                                            to_date: this.props.to_date,
                                            pickerOpened: true
                                        })
                                    }
                                    onClose={() =>
                                        this.setState({
                                            pickerOpened: false
                                        })
                                    }
                                    onAccept={(dateTime) =>
                                        this.props.handleDateFiltersChange(dateTime.$d, 'to_date')
                                    }
                                    label="To Date"
                                    renderInput={(props) => (
                                        <TextField
                                            {...props}
                                            className="mt-2"
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton edge="end">
                                                            <EventIcon />
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    )}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="col-md-3" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <div>
                            <StartConversation context={this.props.context} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default SearchMenu;
